export const getUniqueEntriesOnly = (arr: string[]) => {
  const occurrences: { [key: string]: number } = {}

  arr.forEach(item => {
    occurrences[item] = (occurrences[item] || 0) + 1
  })

  return arr.filter(item => occurrences[item] === 1)
}

export function groupIntoArrayBy<T, K extends keyof T>(items: T[], key: K): T[][] {
  const map = new Map<T[K], T[]>()

  for (const item of items) {
    const groupKey = item[key]

    if (!map.has(groupKey)) {
      map.set(groupKey, [])
    }
    map.get(groupKey)!.push(item)
  }

  return Array.from(map.values())
}
